export default "__VITE_ASSET__e582fcb4__"